<template>
  <div>Home/Goods/List</div>
</template>

<script>
export default {
  name: 'Home-Goods-List',
  components: {
  },
  data(){
    return {};
  },
  mounted () {
    
  }
}
</script>

<style>

</style>
